import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

/**
 * GallerySection
 * -------------------------------------------------------
 * Full-width photo carousel — shows several images at once and
 * scrolls horizontally (not a single centered square), scaling
 * down to fewer visible images on smaller screens. No lightbox/
 * popup — just the slideshow.
 */
export default function GallerySection({ gallery = [] }) {
  if (gallery.length === 0) return null;

  const hasMultiple = gallery.length > 1;

  const settings = {
    dots: false,
    arrows: hasMultiple,
    infinite: gallery.length > 3,
    speed: 500,
    slidesToShow: Math.min(3, gallery.length),
    slidesToScroll: 1,
    autoplay: hasMultiple,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(2, gallery.length),
        },
      },
      {
        breakpoint: 640,
        settings: {
          arrows: false,
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="containers-min mx-auto px-4 pb-16">
      <h3 className="font-gilroy mb-6">Gallery</h3>

      <Slider {...settings} className="gallery-slider">
        {gallery.map((img, i) => (
          <div key={i} className="px-2">
            <div className="aspect-square rounded-2xl overflow-hidden shadow-[0_0_15px_rgba(0,0,0,0.1)]">
              <img
                src={img.src}
                alt={img.alt || `Gallery photo ${i + 1}`}
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}